import React, {useEffect, useState} from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import {Box, Dialog, IconButton} from "@mui/material";
import localStrings from "../localStrings";
import CloseIcon from "@mui/icons-material/Close";
import SelectorPeriod from "../layouts/dashboard/selectorPeriod/selectorPeriod";

function DateSelectorDialogMobile({openDatePicker, setOpenDatePicker}) {
  return (
      <Dialog
          open={openDatePicker}
          onClose={() => setOpenDatePicker(false)}
          fullWidth
          maxWidth="sm"

      >
          <DialogTitle
              sx={{
                  m: 0,
                  p: 2,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
              }}
          >
              <Box component="span">
                  {localStrings.periodSelector}
              </Box>
              <IconButton
                  aria-label="fermer"
                  onClick={() => setOpenDatePicker(false)}
                  sx={{
                      color: (theme) => theme.palette.grey[500]
                  }}
              >
                  <CloseIcon />
              </IconButton>
          </DialogTitle>

          {/* Ton composant ici */}
          <SelectorPeriod  setOpenDatePicker={setOpenDatePicker}/>
      </Dialog>
  )
}

export default DateSelectorDialogMobile